import { define } from 'wicked-elements'

define('[data-component~="project-jump-navigation"]', {
  connected () {
    const projectNavigation = document.querySelector('[data-project-navigation]')
    if (!projectNavigation) return

    this.updateVisibility = () => {
      const isVisible = projectNavigation.getBoundingClientRect().bottom <= 4

      this.element.classList.toggle('is-visible', isVisible)
      this.element.toggleAttribute('inert', !isVisible)
      this.element.setAttribute('aria-hidden', String(!isVisible))
    }

    this.updateVisibility()
    window.addEventListener('scroll', this.updateVisibility, { passive: true })
    window.addEventListener('resize', this.updateVisibility)
    window.addEventListener('load', this.updateVisibility)
    window.addEventListener('pageshow', this.updateVisibility)

    this.links = [...this.element.querySelectorAll('a[href^="#"]')]
    this.sections = this.links
      .map(link => document.getElementById(decodeURIComponent(link.hash.slice(1))))
      .filter(Boolean)
    this.visibleSections = new Set()

    this.sectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.visibleSections.add(entry.target)
        } else {
          this.visibleSections.delete(entry.target)
        }
      })

      const activeSection = this.sections.find(section => this.visibleSections.has(section))

      this.links.forEach(link => {
        const isActive = activeSection?.id === decodeURIComponent(link.hash.slice(1))
        link.classList.toggle('is-active', isActive)
        if (isActive) {
          link.setAttribute('aria-current', 'location')
        } else {
          link.removeAttribute('aria-current')
        }
      })
    }, {
      rootMargin: '-25% 0px -74% 0px'
    })

    this.sections.forEach(section => this.sectionObserver.observe(section))
  },
  disconnected () {
    window.removeEventListener('scroll', this.updateVisibility)
    window.removeEventListener('resize', this.updateVisibility)
    window.removeEventListener('load', this.updateVisibility)
    window.removeEventListener('pageshow', this.updateVisibility)
    this.sectionObserver?.disconnect()
  }
})
